import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    Label,
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
} from "@headlessui/react";
import {
    CheckIcon,
    ChevronUpDownIcon,
    EyeIcon,
    EyeSlashIcon,
} from "@heroicons/react/20/solid";
import { ThreeCircles } from "react-loader-spinner";

//Importo Alert
import { AlertRed, AlertGreen } from "./componets/Alert";
import { api } from "../apiClient.js"
import { useUser } from "../context/UserContext.jsx";

function LoginPage() {
    const { fetchUser } = useUser()

    const navigate = useNavigate();

    const lingue = [
        {
            id: 1,
            name: "Italiano",
            avatar: `${process.env.REACT_APP_URL_FILESERVER}/flag/it.png`,
        },
    ];

    // Dichiaro le Variabili
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [selected, setSelected] = useState(lingue[0]);
    const [textRedAlert, setextRedAlert] = useState("");
    const [textGreenAlert, setextGreenAlert] = useState("");
    const [loadingAlertRed, setloadingAlertRed] = useState(false);
    const [loadingAlertGreen, setloadingAlertGreen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loadingSpinner, setloadingSpinner] = useState(false);

    const stored_session = useSelector((state) => state.session.session);

    // Gestione dei campi del form
    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    //Funzione recovery pw
    const handleRecovery = async () => {
        navigate("/recovery");
    };

    // Funzione per il login
    const handleLogin = async () => {
        if (!username && !password) {
            setextRedAlert(
                "Attenzione! I campi non possono essere vuoti, si prega di riprovare.",
            );
            setloadingAlertRed(true);
            setTimeout(() => {
                setloadingAlertRed(false);
                setextRedAlert("");
            }, 2000);
        } else {
            try {
                let config = {
                    method: "post",
                    maxBodyLength: Infinity,
                    url: `/users/login`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        username: username,
                        password: password,
                    },
                };

                const response = await api.request(config);

                if (response.data.status === true) {
                    setextGreenAlert("Accesso effettuato con successo.");
                    setloadingAlertGreen(true);

                    setTimeout(() => {
                        setloadingAlertGreen(false);
                        setextGreenAlert("");
                    }, 2000);

                    setloadingSpinner(true);

                    setTimeout(() => {
                        setloadingSpinner(false);
                    }, 2000);

                    navigate("/dashboard");
                    await fetchUser()

                    setUsername("");
                    setPassword("");
                } else {
                    setextRedAlert(
                        "Attenzione! Credenziali errate si prega di riprovare.",
                    );
                    setloadingAlertRed(true);
                    setTimeout(() => {
                        setloadingAlertRed(true);
                        setextRedAlert("");
                    }, 2000);
                }

                return response.data;
            } catch (error) {
                setextRedAlert(error.status === 401 ? "Credenziali errate" : "Errore durante il login");
                setloadingAlertRed(true);
                setTimeout(() => {
                    setloadingAlertRed(false);
                    setextRedAlert("");
                }, 2000);
            }
        }
    };

    return (
        <>
            <div className="flex min-h-screen flex-1">
                <div className="flex flex-1 flex-col justify-center mx-10 lg:mx-0 px-4 py-12 sm:px-6 xl:flex-none xl:px-20 xl:px-24">
                    <div className="mx-auto w-full max-w-sm lg:w-96">
                        <div>
                            <img
                                alt="Logo Centro del Sorriso di Cuneo"
                                src={`${process.env.REACT_APP_URL_FILESERVER}/logo_top.png`}
                                className="h-20 w-auto"
                            />
                            <h2 className="mt-2 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                                Effettua l'accesso al tuo account
                            </h2>
                            {stored_session && (
                                <div className="w-full col-span-12 flex justify-center items-center top-0 absolute z-50 mt-4">
                                    <div className="flex items-center w-full max-w-xs p-4 mb-4 text-white bg-red-600 rounded-lg shadow" role="alert">
                                        <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-red-500 rounded-lg">
                                            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 20 20">
                                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
                                            </svg>
                                            <span className="sr-only">Error icon</span>
                                        </div>
                                        <div className="ms-3 text-sm font-normal">Sessione scaduta</div>
                                        <button type="button" className="ms-auto -mx-1.5 -my-1.5 rounded-lg p-1.5 inline-flex items-center justify-center h-8 w-8 text-white" data-dismiss-target="#toast-danger" aria-label="Close">
                                            <span className="sr-only">Close</span>
                                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {loadingAlertRed ? (
                            <AlertRed testo={textRedAlert} />
                        ) : null}
                        {loadingAlertGreen ? (
                            <AlertGreen testo={textGreenAlert} />
                        ) : null}

                        <form onSubmit={(e) => {
                            e.preventDefault(); // prevenire il refresh della pagina
                            handleLogin();      // la tua funzione di login
                        }}>
                            <div className="mt-6">
                                <div>
                                    <div className="space-y-4">
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Nome Utente
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    onChange={handleUsernameChange}
                                                    value={username}
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    autoComplete="email"
                                                    className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label
                                                htmlFor="password"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Password
                                            </label>
                                            <div className="mt-1 relative">
                                                <input
                                                    onChange={handlePasswordChange}
                                                    value={password}
                                                    id="password"
                                                    name="password"
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    } // Mostra/nasconde la password
                                                    autoComplete="current-password"
                                                    className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                <span
                                                    onClick={
                                                        togglePasswordVisibility
                                                    }
                                                    className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-500"
                                                >
                                                    {showPassword ? (
                                                        <EyeSlashIcon
                                                            className="h-5 w-5 text-gray-400"
                                                            aria-hidden="true"
                                                        />
                                                    ) : (
                                                        <EyeIcon
                                                            className="h-5 w-5 text-gray-400"
                                                            aria-hidden="true"
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        </div>

                                        <Listbox
                                            value={selected}
                                            onChange={setSelected}
                                        >
                                            <Label className="block text-sm font-medium leading-6 text-gray-900">
                                                Lingua
                                            </Label>
                                            <div
                                                className="relative"
                                                style={{ marginTop: "0.25rem" }}
                                            >
                                                <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                                                    <span className="flex items-center">
                                                        <img
                                                            src={selected.avatar}
                                                            alt=""
                                                            className="h-5 w-5 flex-shrink-0 rounded-full"
                                                        />
                                                        <span className="ml-3 block truncate">
                                                            {selected.name}
                                                        </span>
                                                    </span>
                                                    <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                                        <ChevronUpDownIcon
                                                            className="h-5 w-5 text-gray-400"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </ListboxButton>

                                                <ListboxOptions className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                    {lingue.map((person) => (
                                                        <ListboxOption
                                                            key={person.id}
                                                            className={({
                                                                active,
                                                            }) =>
                                                                `${active ? "bg-indigo-600 text-white" : "text-gray-900"} relative cursor-default select-none py-2 pl-3 pr-9`
                                                            }
                                                            value={person}
                                                        >
                                                            {({
                                                                selected,
                                                                active,
                                                            }) => (
                                                                <>
                                                                    <div className="flex items-center">
                                                                        <img
                                                                            src={
                                                                                person.avatar
                                                                            }
                                                                            alt=""
                                                                            className="h-5 w-5 flex-shrink-0 rounded-full"
                                                                        />
                                                                        <span
                                                                            className={`${selected ? "font-semibold" : "font-normal"} ml-3 block truncate`}
                                                                        >
                                                                            {
                                                                                person.name
                                                                            }
                                                                        </span>
                                                                    </div>

                                                                    {selected ? (
                                                                        <span
                                                                            className={`${active ? "text-white" : "text-indigo-600"} absolute inset-y-0 right-0 flex items-center pr-4`}
                                                                        >
                                                                            <CheckIcon
                                                                                className="h-5 w-5"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </span>
                                                                    ) : null}
                                                                </>
                                                            )}
                                                        </ListboxOption>
                                                    ))}
                                                </ListboxOptions>
                                            </div>
                                        </Listbox>

                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                <input
                                                    id="remember-me"
                                                    name="remember-me"
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                                />
                                                <label
                                                    htmlFor="remember-me"
                                                    className="ml-3 block text-sm leading-6 text-gray-700"
                                                >
                                                    Ricordami
                                                </label>
                                            </div>

                                            <div className="text-sm leading-6">
                                                <button
                                                    onClick={() => handleRecovery()}
                                                    className="font-semibold text-indigo-600 hover:text-indigo-500"
                                                >
                                                    Password dimenticata?
                                                </button>
                                            </div>
                                        </div>

                                        <div>
                                            <button
                                                type="submit"
                                                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                {loadingSpinner ? (
                                                    <ThreeCircles
                                                        visible={true}
                                                        height="20"
                                                        width="20"
                                                        color="#FFFFFF"
                                                    />
                                                ) : null}
                                                Accedi
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="relative hidden w-0 flex-1 xl:block">
                    <img
                        className="absolute inset-0 h-full w-full xl:object-cover"
                        src={`${process.env.REACT_APP_URL_FILESERVER}/logo.png`}
                        alt=""
                    />
                </div>
            </div>
        </>
    );
}

export default LoginPage;
